import React from "react";
import Lottie from "lottie-react";
import Typography from "@mui/material/Typography";
import load_animation from "./load_animation.json";
export function LoadingComponent({ message }: { message: string }) {
  // Options pour l'animation Lottie

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
        marginTop: "50px",
      }}
    >
      <Lottie
        animationData={load_animation} // Directement passé comme prop
        loop={true}
        autoplay={true}
        style={{ width: "30%", height: "30%" }}
      />
      {/* <Typography variant="h6" style={{ textAlign: "center", color: "#555" }}>
        Just a moment...
      </Typography> */}
      <Typography
        variant="body1"
        style={{
          textAlign: "center",
          color: "#777",
          fontSize: "calc(0.4em + 0.6vw)", // Utilisation de vw pour une taille de police responsive
        }}
      >
        {message}
      </Typography>
    </div>
  );
}
